import React from 'react';

import { Segmented } from 'antd';

import styled from 'styled-components';

const StyledSegmented = styled(Segmented)`
    &&& {
        align-self: ${(props) => (props.$fullWidth ? 'stretch' : 'flex-start')};
        display: ${(props) => (props.$fullWidth ? 'flex' : 'inline-flex')};
        max-width: 100%;
        width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
    }

    &&& .ant-segmented-group {
        width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
    }

    &&& .ant-segmented-item {
        flex: ${(props) => (props.$fullWidth ? '1 1 0' : '0 0 auto')};
    }
`;

const NwSegmented = ({ block, fullWidth = false, ...props }) => {
    const useFullWidth = Boolean(fullWidth || block);

    return <StyledSegmented {...props} $fullWidth={useFullWidth} block={useFullWidth} />;
};

export default NwSegmented;
